import { Addon, Lead } from './../components/islands/OrderForm/types.ts';
import { Order, Product, Variant } from '../components/islands/OrderForm/types.ts';

import iconTehdas from '../assets/images/icon-tehdas.svg';

declare global {
  interface String {
    cleanup(): string;
  }
}

String.prototype.cleanup = function (): string {
  return this.toLowerCase()
    .replaceAll('ä', 'a')
    .replaceAll('ö', 'o')
    .replace(/[^a-zA-Z0-9]+/g, '-');
};

export const getVariation = ({ contractTemplateId, products }: { contractTemplateId: string, products: Product[] }) => {
  for (const product of products) {
    const variation = product.variants.find((variant: Variant) => variant.contract_template_id == contractTemplateId);
    if (variation) {
      if (product.override_terms_link) {
        variation.override_terms_link = product.override_terms_link; // Set override terms link to variation from product group
      }
      return variation
    }
  }
}

export const getVariantByProductId = (productId: string, products: Product[]) => {
  for (const product of products) {
    const variation = product.variants.find((variant: Variant) => variant.hs_id == Number(productId));
    if (variation) {
      return variation;
    }
  }
  return;
}

export const getAdditionalService = (addonProductTemplateNo: string, additionalServices: Addon[]) => {
  for (const service of additionalServices) {
    if ('addon_product_template_no' in service && service['addon_product_template_no'] == addonProductTemplateNo) {
      return service;
    }
  }
}

export const getAdditionalServices = ({ additionalServices, selectedServices }: { additionalServices: Addon[], selectedServices: string }) => {
  const selectedServicesArray = selectedServices.split(',');
  const services = additionalServices.filter(service => selectedServicesArray.includes(service.addon_product_template_no) && service.addon_product_template_no !== '');
  return services;
}

export const getLeads = ({ leads, selectedServices }: { leads: Lead[], selectedServices: string }) => {
  const selectedServicesArray = selectedServices.split(',');
  const services = leads.filter(lead => selectedServicesArray.includes(lead.hs_id.toString()));
  return services;
}

export const getServices = ({ addOns, apartmentType, electricHeating, variation }: { addOns: Addon[], apartmentType: string, electricHeating: string | undefined, variation: Variant | undefined }) => {
  const isMatch = (variation: Variant | undefined, service: Addon) => variation && service.products.map(p => p.id).includes(variation.hs_id);
  const availableServices = addOns.filter(service => {
    const aparmentCheckRequired = service.apartment_types && service.apartment_types.length > 0 && apartmentType && service.apartment_types.map(type => type.label).includes(apartmentType);
    const aparmentCheckPassed = aparmentCheckRequired || !service.apartment_types || service.apartment_types.length == 0;
    // Seems not to be used
    // const sizeCheckRequired = service.apartment_size && formValues['apartment-size'] && checkIfBetween(formValues['apartment-size'], service.apartment_size);
    // const sizeCheckPassed = sizeCheckRequired || !service.apartment_size;
    const heatingCheckRequired = (service.elecrtic_heating && service.elecrtic_heating.name == 'YES' && electricHeating == 'on') || (service.elecrtic_heating && service.elecrtic_heating.name == 'NO' && !electricHeating);
    const heatingCheckPassed = heatingCheckRequired || !service.elecrtic_heating;
    return isMatch(variation, service) && heatingCheckPassed && aparmentCheckPassed;
  })
  return availableServices;
}

export const getRecommendation = (preferences: string, products: Product[]) => {
  let recommended = '';
  if (preferences === 'Ekologinen') {
    recommended = 'Aurinkosähkö'
  }
  if (preferences === 'Pörssihintainen') {
    recommended = 'Pörssisähkö'
  }
  if (preferences === 'Kiinteä') {
    recommended = 'Vuosisähkö'
  }
  if (preferences === 'Edullinen') {
    recommended = 'Vuosisähkö'
  }

  return products.find(product => product.name === recommended);
}

export const getb2bRecommendation = (preferences: string, products: Product[]) => {
  let recommended = '';

  if (preferences === 'Pörssihintainen') {
    recommended = "Pörssisähkö";
  }
  if (preferences === 'Kiinteä') {
    recommended = "Joustosähkö";
  }
  if (preferences === 'Edullinen') {
    recommended = "Synergiasähkö";
  }
  return products.find(product => product.name.includes(recommended));
}

export const getSekasahkoAddon = ({ consumption, includeVAT }: { consumption: string, includeVAT: boolean }): Addon => {
  const emissions = Math.round(parseInt(consumption) * 0.45);
  // [13.26 19.2.2024] Niko Pehkonen:  (kulutusennuste * 0,45 kg/kWh)/ (0,25998 kg/km * 1576km)
  const flightsAmount = Math.round(parseInt(consumption) * 0.45 / (0.25998 * 1576));
  const secondRow = includeVAT ? `Vastaa noin ${flightsAmount} Helsinki-München lentomatkaa` : 'Sisältää fossiilisia energialähteitä';
  const description = `
    <ul>
      <li>CO²-päästöt <b>${emissions} kg/vuosi</b></li>
      <li>${secondRow}</li>
    </ul>`;

  const secondRow_en = includeVAT ? `Roughly equal to ${flightsAmount} flights between Helsinki and Munich` : 'Contains fossil energy sources';
  const description_en = `
    <ul>
      <li>${emissions} kg of CO₂ emissions per year</li>
      <li>${secondRow_en}</li>
    </ul>`;
  return {
    addon_product_template_no: '',
    type: { label: 'Sekasähkö', name: 'Sekasahko', id: 0, isHubspotDefined: false, labelTranslations: {}, type: '', createdAt: 0, createdByUserId: 0, updatedAt: 0, updatedByUserId: 0, order: 0 },
    monthly_price: 0,
    description,
    description_en: description_en,
    icon: { url: iconTehdas as string, altText: 'Tehdas', width: 50, height: 50, fileId: 0, type: '' },
    class: 'sekasahko',
    group: { label: 'Sähkön alkuperä', name: 'Sähkön alkuperä', id: 0, isHubspotDefined: false, labelTranslations: {}, type: '', createdAt: 0, createdByUserId: 0, updatedAt: 0, updatedByUserId: 0, order: 0 },
    name: 'Sekasähkö',
    hs_id: 0,
    hs_child_table_id: 0,
    hs_updated_at: 0,
    hs_published_at: 0,
    vat: { label: '25.5%', name: '25.5%', id: 0, isHubspotDefined: false, labelTranslations: {}, type: '', createdAt: 0, createdByUserId: 0, updatedAt: 0, updatedByUserId: 0, order: 0 },
    products: [],
    hs_initial_published_at: 0,
    hs_created_by_user_id: 0,
    hs_created_at: 0,
    hs_is_edited: false,
    hs_deleted_at: 0,
    hs_updated_by_user_id: 0,
    elecrtic_heating: undefined,
    apartment_types: []
  }
}

export const calculateComsumptionEstimate = ({ area, apartmentType, electricHeating, electricSauna }: { area: string, apartmentType: string, electricHeating: string | undefined, electricSauna: string | undefined }) => {
  // rivi- ja kerrostaloasunnolle: neliöt * 35 kWh + (kiukaiden määrä * 500 kWh)
  // Omakotitalolle: neliöt * 43 kWh * (1 + 1,6 * sähkölämmityskerroin) + (kiukaiden määrä * 500 kWh)
  // Mökki: neliöt * 25 kWh * (1 + 3 * sähkölämmityskerroin) + (kiukaiden määrä * 500 kWh)
  // jossa sähkölämmityskerroin 0-1 sen mukaan onko sitä valittu vai ei.
  const usages = { 'rivitalo': 35, 'kerrostalo': 35, 'omakotitalo': 43, 'mokki': 25 }

  const usageFactor = usages[apartmentType as keyof typeof usages];
  const heatingFactor = electricHeating ? 1.6 : 0;
  const amountOfSaunas = electricSauna ? 1 : 0;
  const useHeatingFactor = electricHeating ? 1 : 0;

  const consumption = parseInt(area) * usageFactor * (1 + heatingFactor * useHeatingFactor) + (amountOfSaunas * 500);
  return consumption

}

export function isJWT(token: string) {
  if (token) {
    try {
      const parts = token.split('.');

      if (parts.length != 3 && parts.length != 5) {
        return false;
      }

      const base64Header = parts[0];
      var base64 = base64Header.replace(/-/g, '+').replace(/_/g, '/');
      var jsonHeader = decodeURIComponent(
        window
          .atob(base64)
          .split('')
          .map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join('')
      );
      const header = JSON.parse(jsonHeader);
      return header.cty == 'JWT' && header.alg == 'RSA-OAEP';
    } catch (e) {
      return false;
    }
  }
}

export const checkCookie = (name: string) => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) {
    return match[2];
  } else {
    return false;
  }
};

export const generateSegmentName = (formData: Order, products: Product[]) => {
  const product = getVariation({ contractTemplateId: formData['product'], products });
  const apartmentType = formData['apartment-type'];
  const consumptionEstimate = parseInt(formData['consumption-estimate']);
  let consumptionCategory = '';
  if (consumptionEstimate < 2000) {
    consumptionCategory = 'pienikulutus';
  } else if (consumptionEstimate >= 2000 && consumptionEstimate < 5000) {
    consumptionCategory = 'keskisuurikulutus';
  } else {
    consumptionCategory = 'suurikulutus';
  }
  let name = '';
  if (product) {
    name = product.name;
  }
  const segmentName = apartmentType ? `${String(name).cleanup()}_${apartmentType}_${consumptionCategory}` : `${String(name).cleanup()}_${consumptionCategory}`;
  return segmentName;
}

export const sha256 = async (message: string) => {
  // https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest
  const msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', msgUint8); // hash the message
  const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, '0'))
    .join(''); // convert bytes to hex string
  return hashHex;
}


export const getAddress = (formValues: Order, type: 'location' | 'invoice') => {
  const postalCode = formValues[`${type}-postalcode`];
  const city = formValues[`${type}-city`];
  const street = formValues[`${type}-street`];
  const house = formValues[`${type}-house`];
  const stairway = formValues[`${type}-stairway`];
  const flat = formValues[`${type}-flat`];
  return `${street} ${house}${stairway ? ' ' + stairway : ''}${flat ? ' ' + flat : ''}, ${postalCode} ${city}`;
}

export const getPeriodNumberFromLabel = (label: string): number | undefined => {
  const parts = label.split(' ');
  if (parts.length > 1) {
    const numberPart = parts[0].replace(/[^0-9]/g, ''); // Remove non-numeric characters
    const number = parseInt(numberPart, 10);
    return isNaN(number) ? undefined : number;
  }
  return undefined;
}
